"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _Plugin2 = _interopRequireDefault(require("./Plugin"));

var PIXI = _interopRequireWildcard(require("pixi.js-legacy"));

var _ = require("../../../");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _get() { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(arguments.length < 3 ? target : receiver); } return desc.value; }; } return _get.apply(this, arguments); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var SCALE_STEP = 40;
var TAIL_COUNT = 8;
var tailColor = 0xf8e81c; //'rgba(248,232,28, 0.2)'

var fieldFill = 0x000000; // 'rgba(0,0,0,0.3)'

var fieldFillOpacity = 0.6;
var fieldStroke = 0xebebeb;
var fieldStrokeOpacity = 1;
var fieldCramFactor = 0.9;
var defaultFieldData = {
  aspect: 1.525574041,
  ratio_rc_w: 0.08200900689,
  ratio_wp_w: 0.1478850944,
  ratio_hp_h: 0.5510345057,
  ratio_wg_w: 0.04929503147,
  ratio_hg_h: 0.2502216242,
  ratio_wd_w: 0.09859006293,
  ratio_rd_w: 0.08200900689
};
var loader = PIXI.Loader.shared;

var Radar = /*#__PURE__*/function (_Plugin) {
  _inherits(Radar, _Plugin);

  var _super = _createSuper(Radar);

  function Radar() {
    var _this;

    _classCallCheck(this, Radar);

    _this = _super.call(this);
    _this._name = "Radar";

    _this.setData({
      setup: {
        field: {
          aspect: 1.900679768481596,
          coordinates: {},
          name: "none",
          ratio_hg_h: 0.3449167904452737,
          ratio_hp_h: 0.7595708554614496,
          ratio_rc_w: 0.09073511386950228,
          ratio_rd_w: 0.09073511386950228,
          ratio_wd_w: 0.10908046476115028,
          ratio_wg_w: 0.05454023238057514,
          ratio_wp_w: 0.16362069714172542
        }
      }
    });

    _this.goodData = true;
    _this.mouseOver = false;
    _this.mini = true;
    _this.wasMini = true;
    _this.hoverPlayer = null;
    _this.fieldAspect = 4 / 3;
    _this.fieldFrame = _this.makeRect(0, 0, 1, 1);
    _this.focusPlayerTraceNumber = "";
    _this.focusPlayersTraceNumbers = [];
    _this.isLoading = false;
    _this.lastLoadedUrl = "";
    _this.controlsVideo = true; // shapes

    _this.fieldBG = null;
    _this.field = null;
    _this.playerShapes = {};
    _this.playerTrails = {};
    _this.playerFrames = {};
    _this.playerHeadings = {};
    _this.cameraShapes = {};
    _this.lastCameraName = ""; // Play/ause

    _this.radarPaused = false;
    return _this;
  }

  _createClass(Radar, [{
    key: "sizeToVideo",
    value: function sizeToVideo() {
      return false;
    }
  }, {
    key: "requiresCanvas",
    value: function requiresCanvas() {
      return true;
    }
  }, {
    key: "sport",
    get: function get() {
      return this.moment ? this.moment.sport_type : "soccer";
    } //// Plugin callbacks

  }, {
    key: "reset",
    value: function reset() {
      _get(_getPrototypeOf(Radar.prototype), "reset", this).call(this);

      for (var key in this.playerShapes) {
        var shape = this.playerShapes[key];
        this.scene.removeChild(shape);
        shape.alpha = 0;
      }

      for (var _key in this.cameraShapes) {
        var _shape = this.cameraShapes[_key];
        this.scene.removeChild(_shape);
        _shape.alpha = 0;
      }

      this.playerShapes = null;
      this.playerShapes = {};
      this.cameraShapes = null;
      this.cameraShapes = {};
      this.playerTrails = {};
      this.playerFrames = [];
      this.playerHeadings = {};
      this.fieldBG = null;
      this.field = null;
      this.focusPlayerTraceNumber = "";
      this.focusPlayersTraceNumbers = [];

      if (this.loader) {
        try {
          this.loader.reset();
        } catch (e) {
          console.error("Radar.reset error", e);
        }
      }
    }
  }, {
    key: "videoPlay",
    value: function videoPlay() {
      this.radarPaused = false;
      return true;
    }
  }, {
    key: "videoPause",
    value: function videoPause() {
      this.radarPaused = true;
      return true;
    }
  }, {
    key: "setup",
    value: function setup(frame, videoInfo, pixi) {
      var _this2 = this;

      this.moment = videoInfo.moment;

      _get(_getPrototypeOf(Radar.prototype), "setup", this).call(this, frame, videoInfo, pixi); //const bounds = this.getBounds(this.safeVideoArea)


      if (!this.scene) {
        return;
      }

      if (this.data && this.data.setup && this.data.setup.athletes) {
        var loaderOptions = {
          loadType: PIXI.LoaderResource.LOAD_TYPE.IMAGE,
          xhrType: PIXI.LoaderResource.XHR_RESPONSE_TYPE.BLOB
        };

        if (!loader.loading) {
          this.avatarsLoaded = false;
          var loadingCount = 0;

          for (var key in this.data.setup.athletes) {
            var player = this.data.setup.athletes[key];
            var resourceName = "avatar-".concat(player.user_id);

            if (!loader.resources[resourceName]) {
              loadingCount++;
              loader.add(resourceName, "https://lapi.traceup.com/tracebot-".concat(process.env.REACT_APP_TRACE_ENV, "/avatars?user=").concat(player.user_id), loaderOptions);
            }
          }

          if (loadingCount > 0) {
            loader.load(function () {
              _this2.avatarsLoaded = true;
            });
          } else {
            this.avatarsLoaded = true;
          }
        }
      } //this.update(frame, videoInfo)

    } /// Radar loader

  }, {
    key: "ensureDataLoaded",
    value: function ensureDataLoaded(moment) {
      var _this3 = this;

      var basePath = moment ? moment.base_path : "";
      var url = "".concat(basePath).concat(moment === null || moment === void 0 ? void 0 : moment.dynamic_jfile);
      var phoneUrl = "".concat(basePath).concat(moment === null || moment === void 0 ? void 0 : moment.dynamic_jfile).replace("dynamic", "phone");

      if (process.env.REACT_APP_VIDEO_PLAYER_API && !(moment !== null && moment !== void 0 && moment.base_path.includes("http"))) {
        url = "".concat(process.env.REACT_APP_VIDEO_PLAYER_API).concat(url);
        phoneUrl = "".concat(process.env.REACT_APP_VIDEO_PLAYER_API).concat(phoneUrl);
      }

      if (this.lastLoadedUrl !== url) {
        this.lastLoadedUrl = url;
        this.reset();
        this.needsSetup = true;
        this.isLoading = true;

        if ((moment === null || moment === void 0 ? void 0 : moment.dynamic_jfile) === "no-radar.json") {
          this.goodData = false;
        } else {
          // this timeout allows inital video to load super fast
          if (this.loadingTimeout) {
            clearTimeout(this.loadingTimeout);
            this.loadingTimeout = null;
          }

          this.loadingTimeout = setTimeout(function () {
            _this3.loadingTimeout = null;

            _this3.loadData(url, phoneUrl);
          }, 750);
        }
      }
    }
  }, {
    key: "loadData",
    value: function () {
      var _loadData = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(url, phoneUrl) {
        var _this4 = this;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                this.isLoading = true;
                (0, _.limiter)({
                  name: "Radar.loadData",
                  url: url,
                  phoneUrl: phoneUrl
                }, /*#__PURE__*/function () {
                  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(success, failure) {
                    var data;
                    return regeneratorRuntime.wrap(function _callee$(_context) {
                      while (1) {
                        switch (_context.prev = _context.next) {
                          case 0:
                            _context.prev = 0;
                            _context.next = 3;
                            return fetch(url).then(function (response) {
                              return response.json();
                            });

                          case 3:
                            data = _context.sent;
                            success();

                            if (data) {
                              _this4.setData(data);
                            }

                            _context.next = 12;
                            break;

                          case 8:
                            _context.prev = 8;
                            _context.t0 = _context["catch"](0);
                            failure();
                            console.warn("Radar.loadData failed", url, _context.t0);

                          case 12:
                            _this4.isLoading = false;

                          case 13:
                          case "end":
                            return _context.stop();
                        }
                      }
                    }, _callee, null, [[0, 8]]);
                  }));

                  return function (_x3, _x4) {
                    return _ref.apply(this, arguments);
                  };
                }());

              case 2:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function loadData(_x, _x2) {
        return _loadData.apply(this, arguments);
      }

      return loadData;
    }() /// Event Handler

  }, {
    key: "on",
    value: function on(event) {
      var used = false;
      var lastPt;
      var mouseOver = null;
      var touchEvent = false;

      switch (event.type) {
        case "mousemove":
          if (this.mini) {
            mouseOver = this.rectContainsPoint(this.fieldFrame, event.offsetX, event.offsetY);
          }

          this.hoverPlayer = null;

          if (this.mini === false) {
            mouseOver = false;

            var _iterator = _createForOfIteratorHelper(this.playerFrames),
                _step;

            try {
              for (_iterator.s(); !(_step = _iterator.n()).done;) {
                var pf = _step.value;
                var pfHit = this.rectContainsPoint(pf, event.offsetX, event.offsetY);

                if (pfHit) {
                  mouseOver = true;
                  this.hoverPlayer = pf.trace_number;
                  break;
                }
              }
            } catch (err) {
              _iterator.e(err);
            } finally {
              _iterator.f();
            }

            var offField = !this.rectContainsPoint(this.fieldFrame, event.offsetX, event.offsetY);

            if (offField) {
              mouseOver = true;
            }
          }

          break;

        case "mouseup":
          lastPt = event;

          if (event.changedTouches) {
            touchEvent = true;
            lastPt = event.changedTouches[event.changedTouches.length - 1];
          }

          if (this.mini === false) {
            var _iterator2 = _createForOfIteratorHelper(this.playerFrames),
                _step2;

            try {
              for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                var _pf = _step2.value;
                var positionX = (0, _.isSmallMobileScreen)() ? lastPt.globalX : lastPt.offsetX;
                var positionY = (0, _.isSmallMobileScreen)() ? lastPt.globalY : lastPt.offsetY;

                var _pfHit = this.rectContainsPoint(_pf, positionX, positionY);

                if (_pfHit) {
                  used = true;

                  if (this.radarEvent) {
                    this.radarEvent({
                      type: "tracer-click",
                      trace_number: _pf.trace_number
                    });
                  }

                  break;
                }
              }
            } catch (err) {
              _iterator2.e(err);
            } finally {
              _iterator2.f();
            }
          }

          if (!used) {
            var _positionX = touchEvent ? lastPt.globalX : lastPt.offsetX;

            var _positionY = touchEvent ? lastPt.globalY : lastPt.offsetY;

            var hit = this.rectContainsPoint(this.fieldFrame, _positionX, _positionY);

            if (this.mini && hit || !this.mini && !hit) {
              if (this.radarEvent) {
                this.radarEvent({
                  type: "field-click"
                });
              }

              this.mini = !this.mini;
              mouseOver = false;
            }
          }

          break;

        default:
          break;
      }

      if (this.fieldFrame) {
        var tip = this.makeRect(this.fieldFrame.x, this.fieldFrame.y + this.fieldFrame.h, this.fieldFrame.w, 40);
        tip.noRadar = this.data.no_radar;

        if (this.mouseOver) {
          if (this.radarEvent) {
            this.radarEvent({
              type: "field-hover-in",
              detail: tip
            });
          }
        } else {
          if (this.radarEvent) {
            this.radarEvent({
              type: "field-hover-out",
              detail: tip
            });
          }
        }
      }

      if (mouseOver !== null) {
        this.mouseOver = mouseOver;
      }

      return true;
    } //// Updates

  }, {
    key: "videoInfo",
    value: function videoInfo() {
      if (this.mini) {
        return {};
      } else {
        return {
          radar: true,
          active: false
        };
      }
    }
  }, {
    key: "dataToShare",
    value: function dataToShare() {
      if (this.mini) {
        return {};
      } else {
        return {
          radar: true,
          active: false
        };
      }
    }
  }, {
    key: "update",
    value: function update(frame, videoInfo, pixi) {
      this.moment = videoInfo.moment;

      _get(_getPrototypeOf(Radar.prototype), "update", this).call(this, frame, videoInfo, pixi); // reset cameras if needed


      if (videoInfo.camera !== this.lastCameraName && this.scene) {
        this.lastCameraName = videoInfo.camera;

        for (var key in this.cameraShapes) {
          this.scene.removeChild(this.cameraShapes[key]);
        }

        this.cameraShapes = {};
      } // update radar athletes


      var ath = (0, _.getProperty)("moment.radar.players", videoInfo, []);

      if (ath) {
        this.data.setup.athletes = ath;
      } // load radar data


      this.ensureDataLoaded(videoInfo.moment);

      if (this.needsSetup) {
        if (this.scene) {
          this.scene.visible = false;
        }

        return;
      }

      if (!this.avatarsLoaded) {
        // wait for avatars to load
        return;
      } // find focus players


      if (!this.focusPlayersTraceNumbers || this.focusPlayersTraceNumbers.length === 0) {
        var traceNumbers = (0, _.getProperty)("moment.radar.focus_players", videoInfo, []);
        this.focusPlayersTraceNumbers = traceNumbers;
      } // find focus player


      if (!this.focusPlayerTraceNumber) {
        var tn = (0, _.getProperty)("moment.radar.focus_player", videoInfo, "");
        this.focusPlayerTraceNumber = tn;
      } // Hide and show logic


      if (this.isLoading === true) {
        // hide until data is good
        this.scene.visible = false;
        return;
      } else if (!this.videoReady) {
        // hide until video ready
        this.scene.visible = false;
        return;
      } else if (this.sharedData && this.sharedData.spotlight_showing || videoInfo.inactive && this.mini === true) {
        // hide when showing spotlight
        this.scene.visible = false;
      } else {
        // make sure scene is visible
        if (this.scene.visible === false) {
          this.scene.visible = true;
        }
      }

      var bounds = this.getBounds(frame);
      var fieldFrame = this.makeRect(bounds.fx, bounds.fy, bounds.fw, bounds.fh); // generate field if needed

      if (!this.field) {
        var ff = this.makeRect(0, 0, bounds.fw, bounds.fh);

        if (this.sport === "baseball") {
          this.field = this.generateBaseballField(ff, this.fieldData);
        } else {
          this.field = this.generateSoccerField(ff, this.fieldData);
        }

        this.closeButton = this.generateCloseButton(ff, this.fieldData);
        this.origFieldWidth = ff.w;
        this.scene.addChild(this.field);
        this.scene.addChild(this.closeButton);
      }

      var activeFrame = this.makeRect(bounds.x, bounds.y, bounds.w, bounds.h);

      if (this.sport === "baseball") {
        this.updateBaseballField(fieldFrame, this.fieldData);
      } else {
        this.updateSoccerField(fieldFrame, this.fieldData);
      }

      this.playerFrames = [];

      if (this.data.no_radar || this.goodData === false) {
        this.scene.visible = true;
        return;
      } // hack to find first frame with players


      var items = this.findFrameData(videoInfo.currentTime);
      var phoneItems = this.findCameraFrameData(videoInfo.currentTime); // update player positions

      var players = items.a;
      var playerX = 1;

      if (!this.mini) {
        playerX = window.innerWidth > 400 && window.innerHeight > 400 ? 1 : 2.125;
      }

      var playerR = Math.round(bounds.fw * 0.04) * playerX;
      var usedPlayers = [];

      for (var _key2 in players) {
        var entry = players[_key2];
        usedPlayers.push(_key2);
        this.updatePlayer(fieldFrame, activeFrame, playerR, entry, videoInfo, _key2, pixi);
      } // remove unused players


      for (var _key3 in this.playerShapes) {
        var found = false;

        var _iterator3 = _createForOfIteratorHelper(usedPlayers),
            _step3;

        try {
          for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
            var used = _step3.value;

            if (used === _key3) {
              found = true;
              break;
            }
          }
        } catch (err) {
          _iterator3.e(err);
        } finally {
          _iterator3.f();
        }

        if (!found) {
          this.scene.removeChild(this.playerShapes[_key3]);
          delete this.playerShapes[_key3];
          this.removePlayerHeading(_key3);
          this.removePlayerTrails(_key3);
        }
      } // update camera positions


      var usedCameras = [];

      if (this.goodData) {
        var cameras = phoneItems.ph;
        var cameraX = 1;

        if (!this.mini) {
          cameraX = window.innerWidth > 400 && window.innerHeight > 400 ? 1 : 2.125;
        }

        var cameraR = Math.round(bounds.fw * 0.04) * cameraX;

        for (var _key4 in cameras) {
          var _entry = cameras[_key4];
          usedCameras.push(_key4);
          this.updateCamera(fieldFrame, activeFrame, cameraR, _entry, videoInfo, _key4, pixi);
        }
      } // remove unused camera


      for (var _key5 in this.cameraShapes) {
        var _found = false;

        var _iterator4 = _createForOfIteratorHelper(usedCameras),
            _step4;

        try {
          for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
            var _used = _step4.value;

            if (_used === _key5) {
              _found = true;
              break;
            }
          }
        } catch (err) {
          _iterator4.e(err);
        } finally {
          _iterator4.f();
        }

        if (!_found) {
          this.scene.removeChild(this.cameraShapes[_key5]);
          delete this.cameraShapes[_key5];
        }
      }

      if (this.isResizing) {
        this.scene.alpha = 0;
      } else {
        this.scene.alpha = 1;
      }

      this.wasMini = this.mini;
    }
  }, {
    key: "updateCamera",
    value: function updateCamera(curFieldFrame, activeFrame, cameraR, cameraData, vi, key, pixi) {
      var fieldFrame = this.fieldFrame;
      var cameraShape = this.cameraShapes[key];
      var phoneId = (0, _.getProperty)("data.setup.phones.".concat(key, ".id"), this, "tracecam");
      var normalizedCamera = vi.camera;
      normalizedCamera = normalizedCamera.replace("phone-", "").substr(1);

      if (!cameraShape) {
        cameraShape = this.generateCamera(this.makeRect(-50, 0, 100, 87), phoneId.includes(normalizedCamera), pixi);
        this.cameraShapes[key] = cameraShape;
        this.scene.removeChild(cameraShape);
        this.scene.addChild(cameraShape);
      }

      var loc = cameraData["l"];
      var cx = fieldFrame.x + loc[0] * (fieldFrame.w / 1000);
      var cy = fieldFrame.y + loc[1] * (fieldFrame.h / 1000);
      var r = key === "tracecam" ? cameraR * 1.25 : cameraR;

      if (cameraData["h"]) {
        var angle = cameraData["h"][0] * 0.0174533;
        cameraShape.setTransform(cx, cy, r / 100, r / 100, angle);
      } else {
        cameraShape.setTransform(cx, cy, r / 100, r / 100);
      }
    }
  }, {
    key: "updatePlayer",
    value: function updatePlayer(curFieldFrame, activeFrame, playerR, entry, vi, key, pixi) {
      var fieldFrame = this.fieldFrame;
      var playerShape = this.playerShapes[key];
      var athlete = this.data.setup.athletes[key]; // eslint-disable-next-line eqeqeq

      if (this.mini != this.wasMini) {
        this.scene.removeChild(playerShape);
        delete this.playerShapes[key];
        playerShape = null;
      }

      if (this.mini) {
        this.removePlayerTrails(key);
        this.removePlayerHeading(key);
      }

      if (!this.mini && this.playerTrails[key] === undefined) {
        this.generatePlayerTail(this.makeRect(0, 0, 100, 100), key);

        if (playerShape) {
          this.scene.removeChild(playerShape);
          this.scene.addChild(playerShape);
        }
      }

      if (!this.mini && this.playerHeadings[key] === undefined) {
        var heading = this.generatePlayerHeading(this.makeRect(-50, -50, 100, 100), key);
        this.scene.addChild(heading);
      }

      if (!playerShape) {
        playerShape = this.generatePlayer(this.makeRect(-50, -50, 100, 100), athlete, pixi);
        this.playerShapes[key] = playerShape;
        this.scene.removeChild(playerShape);
        this.scene.addChild(playerShape);
      } // update player shape position and size


      var loc = entry["l"];
      var cx = fieldFrame.x + loc[0] * (fieldFrame.w / 1000);
      var cy = fieldFrame.y + loc[1] * (fieldFrame.h / 1000);
      playerShape.setTransform(cx, cy, playerR / 100, playerR / 100);
      this.updatePlayerHeading(this.makeRect(cx, cy, playerR, playerR), key, entry);
      this.updatePlayerTrails(this.fieldFrame, vi.currentTime, playerR); // save player rects for hit testing

      var pf = this.makeRect(cx - playerR, cy - playerR, playerR * 2, playerR * 2);
      pf.trace_number = key;
      this.playerFrames.push(pf);
    }
  }, {
    key: "updatePlayerHeading",
    value: function updatePlayerHeading(frame, playerId, entry) {
      if (this.playerHeadings[playerId]) {
        var scale = frame.w / 100;
        var angle = entry["h"][0] * 0.0174533;
        this.playerHeadings[playerId].setTransform(frame.center.x, frame.center.y, scale, scale, angle);
      }
    }
  }, {
    key: "removePlayerHeading",
    value: function removePlayerHeading(key) {
      this.scene.removeChild(this.playerHeadings[key]);
      delete this.playerHeadings[key];
    }
  }, {
    key: "updatePlayerTrails",
    value: function updatePlayerTrails(frame, time, size) {
      var t = time;

      for (var i = 0; i < TAIL_COUNT; i++) {
        var items = this.findFrameData(t - i * (1 / 6));

        for (var k in this.playerTrails) {
          var cx = 0;
          var cy = 0;
          var player = items.a[k];

          if (player) {
            var loc = player["l"];
            cx = frame.x + loc[0] * (frame.w / 1000) + size / 2;
            cy = frame.y + loc[1] * (frame.h / 1000) + size / 2;
          }

          if (this.playerTrails[k] && this.playerTrails[k][i]) {
            this.playerTrails[k][i].setTransform(cx, cy, size / 100, size / 100);
          }
        }
      }
    }
  }, {
    key: "removePlayerTrails",
    value: function removePlayerTrails(key) {
      if (this.playerTrails[key]) {
        for (var i in this.playerTrails[key]) {
          this.scene.removeChild(this.playerTrails[key][i]);
        }
      }

      delete this.playerTrails[key];
    }
  }, {
    key: "updateBaseballField",
    value: function updateBaseballField(toFrame) {
      var frame = toFrame;
      var fromFrame = this.fieldFrame;

      if (fromFrame.w !== toFrame.w && fromFrame.w !== 1) {
        var dist = this.distance(fromFrame, toFrame);
        var wDiff = Math.abs(fromFrame.w - toFrame.w);
        var scaleSteps = wDiff / SCALE_STEP;
        var pt = this.stepPoint(fromFrame, toFrame, dist / scaleSteps);
        var w = this.stepValue(fromFrame.w, toFrame.w, SCALE_STEP);
        var h = w / toFrame.w * toFrame.h;
        frame = this.makeRect(pt.x, pt.y, w, h);
      }

      this.fieldFrame = frame;
      this.field.x = frame.x;
      this.field.y = frame.y;
      var scale = frame.w / this.origFieldWidth;
      this.field.setTransform(frame.x, frame.y, scale, scale); //this.field.

      this.closeButton.x = frame.x + frame.w + 20;
      this.closeButton.y = frame.y - 20;
      this.closeButton.alpha = this.mini ? 0 : 1;

      if (this.mouseOver) {
        document.body.style.cursor = "pointer";
      } else {
        document.body.style.cursor = "default";
      }
    }
  }, {
    key: "updateSoccerField",
    value: function updateSoccerField(toFrame) {
      var frame = toFrame;
      var fromFrame = this.fieldFrame;

      if (fromFrame.w !== toFrame.w && fromFrame.w !== 1) {
        var dist = this.distance(fromFrame, toFrame);
        var wDiff = Math.abs(fromFrame.w - toFrame.w);
        var scaleSteps = wDiff / SCALE_STEP;
        var pt = this.stepPoint(fromFrame, toFrame, dist / scaleSteps);
        var w = this.stepValue(fromFrame.w, toFrame.w, SCALE_STEP);
        var h = w / toFrame.w * toFrame.h;
        frame = this.makeRect(pt.x, pt.y, w, h);
      }

      this.fieldFrame = frame;
      this.field.x = frame.x;
      this.field.y = frame.y;
      var scale = frame.w / this.origFieldWidth;
      this.field.setTransform(frame.x, frame.y, scale, scale);
      this.closeButton.x = frame.x + frame.w + 20;
      this.closeButton.y = frame.y - 20;
      this.closeButton.alpha = this.mini ? 0 : 1;

      if (this.mouseOver) {
        document.body.style.cursor = "pointer";
      } else {
        document.body.style.cursor = "default";
      }
    } //// Shape Generation

  }, {
    key: "generateCamera",
    value: function generateCamera(frame) {
      var active = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var pixi = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      var yellow = 0xfbc224;
      var transparent = 0x323333;
      var white = 0xffffff;
      var layer = new PIXI.Graphics();
      var pt1 = {
        x: frame.x + frame.w / 2,
        y: frame.y
      };
      var pt2 = {
        x: frame.x,
        y: frame.y + frame.h
      };
      var pt3 = {
        x: frame.x + frame.w,
        y: frame.y + frame.h
      }; //layer.lineStyle(10, white, 1, 0.5)

      layer.lineStyle({
        width: 10,
        color: white,
        alpha: 1,
        alignment: 0.5,
        native: true,
        cap: PIXI.LINE_CAP.ROUND,
        join: PIXI.LINE_JOIN.ROUND,
        miterLimit: 40
      });

      if (active) {
        layer.beginFill(yellow, 1);
      } else {
        layer.beginFill(transparent, 0.2);
      }

      layer.moveTo(pt1.x, pt1.y);
      layer.lineTo(pt2.x, pt2.y);
      layer.lineTo(pt3.x, pt3.y);
      layer.lineTo(pt1.x, pt1.y);
      layer.closePath();
      layer.endFill();
      return layer;
    }
  }, {
    key: "generatePlayer",
    value: function generatePlayer(frame) {
      var playerData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pixi = arguments.length > 2 ? arguments[2] : undefined;
      var abbr = playerData.abbr;

      if (!abbr) {
        abbr = playerData.abr;
      }

      var player = Object.assign({}, {
        id: "key",
        unknown: false,
        abbr: abbr,
        user_id: 0
      }, playerData);
      var layer = new PIXI.Graphics();
      var fillColor = 0xffffff;

      if (playerData.id === this.focusPlayerTraceNumber) {
        fillColor = 0x64c6f6;
      } else if (this.focusPlayersTraceNumbers.includes(playerData.id)) {
        fillColor = 0xc1e8fb;
      } else if (playerData.unknown) {
        fillColor = 0xf44259;
      }

      layer.beginFill(fillColor, 1);
      layer.drawCircle(frame.w / 2, frame.w / 2, frame.w / 2);
      layer.endFill();

      if (!this.mini) {
        var text = new PIXI.Text(player.abbr, {
          fontFamily: "Montserrat",
          fontWeight: "bold",
          fontSize: 41,
          align: "center",
          fill: 0x000000,
          letterSpacing: -2
        });
        text.anchor.set(0, 0);
        var bounds = text.getBounds();
        text.setTransform((frame.w - bounds.width) / 2, 25);
        text.fill = 0xff0000;
        layer.addChild(text);
        var resourceName = "avatar-".concat(player.user_id); // eslint-disable-next-line eqeqeq

        if (loader.resources[resourceName] && // eslint-disable-next-line eqeqeq
        loader.resources[resourceName].error == null) {
          var sprite = new PIXI.Sprite(loader.resources[resourceName].texture);
          sprite.x = 6;
          sprite.y = 6;
          sprite.width = frame.w - 12;
          sprite.height = frame.h - 12;
          var mask = new PIXI.Graphics();
          mask.beginFill(0x000000);
          mask.drawCircle(frame.w / 2, frame.w / 2, (frame.w - 12) / 2);
          mask.endFill();
          layer.addChild(mask);
          sprite.mask = mask;
          layer.addChild(sprite);
        }
      }

      return layer;
    }
  }, {
    key: "generatePlayerTail",
    value: function generatePlayerTail(frame, playerId) {
      var count = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : TAIL_COUNT;
      var shapes = [];

      for (var i = 0; i < count; i++) {
        var w = frame.w * (0.8 - i * 0.04);
        var circle = new PIXI.Graphics();
        circle.beginFill(tailColor, 0.2);
        circle.drawCircle(0, 0, w / 2);
        circle.endFill();
        this.scene.addChild(circle);
        shapes.push(circle);
      }

      this.playerTrails[playerId] = shapes;
      return shapes;
    }
  }, {
    key: "generatePlayerHeading",
    value: function generatePlayerHeading(frame, playerId) {
      var notchR2 = frame.w * 0.7;
      var notchX1 = notchR2 * Math.sin(30 * 0.0174533);
      var notchX2 = notchR2 * Math.sin(15 * 0.0174533);
      var notchY1 = notchR2 * Math.cos(30 * 0.0174533);
      var notchY2 = notchR2 * Math.cos(15 * 0.0174533);
      var path = new PIXI.Graphics();
      path.beginFill(0xffffff);
      path.moveTo(frame.center.x, frame.center.y - frame.w * 1.2);
      path.lineTo(frame.center.x + notchX1, frame.center.y - notchY1);
      path.lineTo(frame.center.x + notchX2, frame.center.y - notchY2);
      path.lineTo(frame.center.x, frame.center.y - notchR2);
      path.lineTo(frame.center.x - notchX2, frame.center.y - notchY2);
      path.lineTo(frame.center.x - notchX1, frame.center.y - notchY1);
      path.closePath();
      path.endFill();
      this.playerHeadings[playerId] = path;
      return path;
    }
  }, {
    key: "generateBaseballField",
    value: function generateBaseballField(frame, fieldData) {
      var lw = frame.w * 0.011; // const baseSize = frame.w * 0.025

      var ptHome = {
        x: frame.center.x,
        y: frame.max.y
      };
      var sideLength = frame.h;
      var right_baseline_ratio = fieldData.baseline_length / fieldData.right_foul_length;
      var baseline_length = sideLength * right_baseline_ratio;
      var ptRightFence = this.pointAtAngle(ptHome, -45, sideLength);
      var ptLeftFence = this.pointAtAngle(ptHome, -135, sideLength);
      var ptFirst = this.pointAtAngle(ptHome, -45, baseline_length);
      var ptSecond = this.pointAtAngle(ptFirst, -135, baseline_length);
      var ptThird = this.pointAtAngle(ptSecond, -225, baseline_length);
      var field = new PIXI.Graphics(); // Field background / boundary

      field.beginFill(fieldFill, 0.3);
      field.moveTo(ptHome.x, ptHome.y);
      field.lineTo(ptLeftFence.x, ptLeftFence.y);
      field.arc(ptHome.x, ptHome.y, frame.h, -135 * (Math.PI / 180), -45 * (Math.PI / 180), false);
      field.lineTo(ptHome.x, ptHome.y);
      field.endFill();
      field.lineStyle(lw, fieldStroke, 0.5, 0.5);
      field.moveTo(ptHome.x, ptHome.y);
      field.lineTo(ptRightFence.x, ptRightFence.y);
      field.moveTo(ptHome.x, ptHome.y);
      field.lineTo(ptLeftFence.x, ptLeftFence.y);
      field.moveTo(ptFirst.x, ptFirst.y);
      field.lineTo(ptSecond.x, ptSecond.y);
      field.lineTo(ptThird.x, ptThird.y);
      return field;
    }
  }, {
    key: "generateSoccerField",
    value: function generateSoccerField(frame, fieldData) {
      var lw = frame.w * 0.011;
      var field = new PIXI.Graphics();
      field.lineStyle(lw, fieldStroke, fieldStrokeOpacity, 0.5); // Field background / boundary

      field.beginFill(fieldFill, fieldFillOpacity);
      field.drawRect(frame.x, frame.y, frame.w, frame.h);
      field.endFill(); // Center line

      field.moveTo(frame.x + frame.w / 2, frame.y);
      field.lineTo(frame.x + frame.w / 2, frame.y + frame.h); // Penalty boxes

      var pw = Math.round(fieldData.ratio_wp_w * frame.w);
      var ph = Math.round(fieldData.ratio_hp_h * frame.h);
      field.drawRect(frame.x, (frame.h - ph) / 2, pw, ph);
      field.drawRect(frame.max.x - pw, (frame.h - ph) / 2, pw, ph); // Goalie Box

      var gw = Math.round(fieldData.ratio_wg_w * frame.w);
      var gh = Math.round(fieldData.ratio_hg_h * frame.h);
      field.drawRect(frame.x, (frame.h - gh) / 2, gw, gh);
      field.drawRect(frame.max.x - gw, (frame.h - gh) / 2, gw, gh); // Center Circle

      var cd = frame.w * fieldData.ratio_rc_w;
      field.drawEllipse(frame.center.x, frame.center.y, Math.round(cd / 2), Math.round(cd / 2));
      field.opacity = 0.5; // No Radar

      if (this.goodData === false) {
        var noRadar = new PIXI.Graphics();
        noRadar.lineStyle(lw * 3, fieldStroke, fieldStrokeOpacity, 0.5);
        var fudge = frame.w * 0.05;
        noRadar.moveTo(frame.x, frame.y + frame.h + fudge);
        noRadar.lineTo(frame.x + frame.w, frame.y - fudge);
        field.addChild(noRadar);
      }

      return field;
    }
  }, {
    key: "generateCloseButton",
    value: function generateCloseButton(frame, fieldData) {
      var button = new PIXI.Graphics();
      button.beginFill(0xffffff, 0.5);
      button.drawEllipse(0, 0, 10, 10);
      button.endFill();
      button.lineStyle(2, 0x000000, 1);
      button.moveTo(-4, -4);
      button.lineTo(4, 4);
      button.moveTo(4, -4);
      button.lineTo(-4, 4); //field.beginFill(fieldFill, fieldFillOpacity)
      //field.drawRect(frame.x, frame.y, frame.w, frame.h)
      //field.endFill()

      return button;
    } //// Helper Methods

  }, {
    key: "setData",
    value: function setData(data) {
      this.data = Object.assign({}, data);
      this.fieldData = Object.assign({}, defaultFieldData, data.setup.field);

      if (data.setup.field_aspect) {
        this.fieldAspect = data.setup.field_aspect;
      }

      this.goodData = // eslint-disable-next-line eqeqeq
      data["frm"] != null && data["frm"].length > 1 && // eslint-disable-next-line eqeqeq
      data.setup != null && // eslint-disable-next-line eqeqeq
      data.setup.field != null;

      if (this.goodData) {
        this.timeline = new RadarTimeLine(data["frm"], data["setup"]["fps"]);
        this.cameraTimeline = new RadarTimeLine(data["frm"], data["setup"]["fps"], "ph");
      }

      this.reset();
    }
  }, {
    key: "findFrameData",
    value: function findFrameData(time) {
      var items = [];

      if (this.timeline) {
        items = this.timeline.findFrame(time);
      }

      return items;
    }
  }, {
    key: "findCameraFrameData",
    value: function findCameraFrameData(time) {
      var items = {};

      if (this.cameraTimeline) {
        items = this.cameraTimeline.findFrame(time); /// hack to get trace cam on radar
        // console.log("findCameraFrameData", items)

        if (this.goodData) {
          if (!items.ph) {
            items.ph = {};
          }

          items.ph["tracecam"] = {
            h: [0, 0],
            l: [500, 1050]
          };
        } /// end hack

      }

      return items;
    }
  }, {
    key: "getBounds",
    value: function getBounds(frame) {
      var fullWidth = frame.w;
      var fullHeight = frame.h;
      var width, height, posX, posY;

      if (this.mini) {
        var f = window.innerWidth < 415 ? 0.2 : 0.15;
        width = fullWidth * f;
        var hwidth = fullHeight * f * this.fieldAspect;

        if (hwidth < width) {
          width = hwidth;
        }

        height = width / this.fieldAspect;
        posX = fullWidth - width - fullWidth * 0.015;

        if (frame.w > frame.h) {
          posY = fullWidth * 0.015;
        } else {
          posY = fullWidth * 0.015 + 56;
        }
      } else {
        width = fullWidth * 0.75;
        height = width / this.fieldAspect;

        if (height >= fullHeight * 0.75) {
          height = fullHeight * 0.75;
          width = height * this.fieldAspect;
        }

        posX = (fullWidth - width) / 2; //~10% of height up from the center

        posY = (fullHeight - height) / 2; //if (fullWidth > 566) {
        //    posY -= (fullHeight - height) * 0.3
        //}
      }

      var deltaW = width - width * fieldCramFactor;
      var deltaH = height - height * fieldCramFactor;
      var deltaX = deltaW / 2;
      var deltaY = deltaH / 2;
      return {
        x: posX + frame.x,
        y: posY + frame.y,
        w: width,
        h: height,
        fx: Math.floor(posX + deltaX) + frame.x,
        fy: Math.floor(posY + deltaY) + frame.y,
        fw: Math.floor(width - deltaW),
        fh: Math.floor(height - deltaH)
      };
    }
  }]);

  return Radar;
}(_Plugin2.default);

exports.default = Radar;

var RadarTimeLine = /*#__PURE__*/function () {
  function RadarTimeLine(frames, fps) {
    var key = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "a";

    _classCallCheck(this, RadarTimeLine);

    this.frames = frames;
    this.startDelta = frames[0]["t"];
    this.offset = this.startDelta; // in 1/100 seconds

    this.numFrames = frames.length;
    this.fps = fps;
    this.key = key;
  }

  _createClass(RadarTimeLine, [{
    key: "findFrame",
    value: function findFrame(timeSeconds) {
      var time = Math.round(timeSeconds * 100);
      var idx = this.getFrameIndex(time);
      var nextIdx = idx + 1;
      var time1 = this.getTimeByIndex(idx);
      var time2 = this.getTimeByIndex(nextIdx);
      var percent = (time - time1) / (time2 - time1);

      if (nextIdx >= this.numFrames || percent < 0.001) {
        return this.frames[idx];
      }

      var frame = {};
      frame["t"] = this.interpolate(time1, time2, percent);
      var athletes = {};
      var idxFrames = this.frames[idx][this.key];

      for (var key in idxFrames) {
        // eslint-disable-next-line no-prototype-builtins
        if (idxFrames.hasOwnProperty(key)) {
          var p1 = idxFrames[key];
          var nextIdKey = this.frames[nextIdx][this.key];
          var p2 = (0, _.getProperty)(key, nextIdKey, undefined);

          if (!p2) {
            athletes[key] = p1;
            continue;
          }

          if (p1["h"] === undefined || p2["h"] === undefined) {
            continue;
          }

          if (p1["l"] === undefined || p2["l"] === undefined) {
            continue;
          }

          var outp = {};
          var loc = [];
          loc[0] = this.interpolate(p1["l"][0], p2["l"][0], percent);
          loc[1] = this.interpolate(p1["l"][1], p2["l"][1], percent);
          outp["l"] = loc;
          var head = [];
          head[0] = this.interpolateAngle(p1["h"][0], p2["h"][0], percent);
          head[1] = this.interpolate(p1["h"][1], p2["h"][1], percent);
          outp["h"] = head;
          athletes[key] = outp;
        }
      }

      frame[this.key] = athletes;
      return frame;
    }
  }, {
    key: "interpolate",
    value: function interpolate(val1, val2, percent) {
      return val1 + (val2 - val1) * percent;
    }
  }, {
    key: "interpolateAngle",
    value: function interpolateAngle(val1, val2, percent) {
      var delta = val2 - val1;

      if (delta > 180) {
        delta -= 360;
      } else {
        if (delta <= -180) {
          delta += 360;
        }
      }

      var ret = (val1 + delta * percent) % 360;
      ret = ret < 0 ? 360 + ret : ret;
      return ret;
    }
  }, {
    key: "getFrameIndex",
    value: function getFrameIndex(time) {
      var time2 = time - this.startDelta + this.offset;
      var idx = Math.floor(time2 / 100 * this.fps);
      return idx < 0 ? 0 : idx < this.numFrames ? idx : this.numFrames - 1;
    }
  }, {
    key: "getTimeByIndex",
    value: function getTimeByIndex(idx) {
      var time2 = Math.floor(idx / this.fps * 100);
      var time = time2 - this.offset + this.startDelta;
      return time;
    }
  }]);

  return RadarTimeLine;
}();